import { CreateWorkflowTemplateRequest } from "../../../service/workflow";
import { sentenceOrPascalToCamel } from "../../../utils";
import { DealWorkflowStage } from "../models";

type CreateWorkflowTemplatePhase = NonNullable<CreateWorkflowTemplateRequest["phases"]>[number];

export const mapDealStagesToPhases = (dealStages: DealWorkflowStage[]): CreateWorkflowTemplatePhase[] => {
  return dealStages.reduce<CreateWorkflowTemplatePhase[]>((phases, stage) => {
    const name = stage.name.trim();

    if (!name) {
      return phases;
    }

    const keyDates = stage.keyDates
      .map((keyDate) => sentenceOrPascalToCamel(keyDate.name.trim()))
      .filter((keyDateName) => keyDateName.length > 0);

    return [
      ...phases,
      {
        keyDates,
        name,
        sequence: phases.length + 1,
      },
    ];
  }, []);
};
